import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { ThemeType } from 'primeng/config';

const preset = definePreset(Aura, {
  semantic: {
    primary: {
      '50': '#9fe6ff',
      '100': '#8bd2ff',
      '200': '#77beff',
      '300': '#63aaff',
      '400': '#4f96ff',
      '500': '#3B82F6',
      '600': '#276ee2',
      '700': '#135ace',
      '800': '#0046ba',
      '900': '#0032a6',
      '950': '#001e92',
    },
    secondary: {
      '50': '#646668',
      '100': '#505254',
      '200': '#3c3e40',
      '300': '#282a2c',
      '400': '#141618',
      '500': '#000204',
      '600': '#000000',
      '700': '#000000',
      '800': '#000000',
      '900': '#000000',
      '950': '#000000',
    },
  },
});

export const theme: ThemeType = {
  preset,
  options: {
    darkModeSelector: '.dark-mode',
  },
};
